/**
 * An object representing HTTP methods.
 *
 * @property {string} post - Represents the HTTP POST method.
 * @property {string} get - Represents the HTTP GET method.
 * @property {string} patch - Represents the HTTP PATCH method.
 */
const httpMethods = {
  post: 'post',
  get: 'get',
  patch: 'patch'
}

export default httpMethods
